/**
 * La KEY "pelada" de licencia: sin espacios y sin el sufijo que Monitor le agrega al
 * doc-id de `users` ("8ecef510cb-2" -> "8ecef510cb").
 *
 * Es la KEY con la que se guarda y se consulta un BANEO: el Escritorio pregunta por la
 * KEY limpia, asi que buscar el baneo con el id de la cuenta (que puede llevar sufijo)
 * da "no baneada" aunque el equipo lo este.
 *
 * La MISMA regla esta en TCADMIN (Upzet/Sites/admin/src/helpers/keyBare.js) y en
 * ticketcontrol-functions-dev/functions/baneo.js: si se cambia una, cambiar las otras.
 */
export const keyBare = (docId) => {
  const k = (docId || "").toString().trim();
  if (/^[0-9a-f]{10}$/i.test(k)) return k;
  const m = k.match(/^([0-9a-f]{10})/i);
  return m ? m[1] : k;
};
